import React, { Component } from 'react'
import { connect } from 'react-redux'
import { googleLogin, twitterLogin } from '../redux/userActions'
import { Button, Image } from 'semantic-ui-react'
import cyberpunk from '../images/cyberpunk.gif'
import street from '../images/street.gif'
import botAvatar from '../images/avatar/smallpilot.png'
import { withRouter } from 'react-router-dom'
import ChatBot from 'react-simple-chatbot'
import ReactRain from 'react-rain-animation'
import Fade from 'react-reveal/Fade';
import './Login.css'

const HOME_PATH = '/inCyberNotes'

export class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      numDrops: 50,
      chatbot: false,
      enableFirstTime: false,
      enableOffline: false,
      enableDirty: false,
      changeBack: 5
    }
  }

  componentWillMount() {
    if (this.props.user != null) {
      this.props.history.push(HOME_PATH)
    }
  }

  onGitHub = () => {
    window.open('http://www.github.com/inPhoenix/', '_blank')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user != null) {
      nextProps.history.push(HOME_PATH)
    }
  }

  changeNumOfDrops = () => {
    console.log('%c raining harder ', 'background:black;color:DarkSlateGray;')
    this.setState(() => ({
      numDrops: 250
    }))
  }

  loginGoogle = () => {
    this.props.googleLogin()
  }

  loginTwitter = () => {
    this.props.twitterLogin()
  }

  helpBot = () => {
    this.setState(prevState => ({
      chatbot: !prevState.chatbot,
      enableFirstTime: true
    }))
    if (this.state.enableDirty && !this.state.chatbot) {
      this.setState({ enableOffline: true })
      setTimeout(() => {
        this.setState({
          enableOffline: false
        })
      }, 3500)
    }
  }

  changeBackground = () => {
    const { changeBack } = this.state
    const LAST_ITEM = 6

    if (changeBack === LAST_ITEM) {
      return this.setState(prevState => ({
        changeBack: 1
      }))
    }
    this.setState(prevState => ({
      changeBack: prevState.changeBack + 1
    }))

  }

  handleEnd = ({ steps, values }) => {
    this.setState(() => ({
      enableOffline: true
    }))

    setTimeout(() => {
      this.setState({
        enableOffline: false,
        enableDirty: true
      })
    }, 12500)
  }

  disconnected = () => {
    return (
      <div color="green">
        <div className="cyberFont backgroundClear blink_me">
          Servers offline
        </div>
      </div>
    )
  }

  render() {
    let trigger = '4'
    const mySteps = [
      {
        id: '1',
        message: 'Hi how can I help you?',
        trigger: '2'
      },
      {
        id: '2',
        user: true,
        trigger: ({ value, steps }) => {
          if (value === 'rain') {
            this.changeNumOfDrops()
            return '4'
          } else {
            return '5'
          }
        }
      },
      {
        id: '4',
        message: 'it is raining cats and dogs',
        trigger: '4.1'
      },
      {
        id: '4.1',
        user: true,
        trigger: '5'
      },
      {
        id: '5',
        message: 'Im sorry, due to the rain, all our servers are offline.',
        end: true
      }
    ]
    const classes = [
      `box-layout`,
      this.state.changeBack === 2 ? `particles--back2` : '',
      this.state.changeBack === 3 ? `particles--back3` : '',
      this.state.changeBack === 4 ? `particles--back4` : '',
      this.state.changeBack === 5 ? `particles--back5` : '',
      this.state.changeBack === 6 ? `particles--back6` : ''
    ]

    return (
      <div className={classes.join(' ')}>
        <ReactRain numDrops={this.state.numDrops} />
        <div className="chatbot-container">
          <Fade when={this.state.chatbot} left>
            {this.state.enableFirstTime && (
              <ChatBot
                headerTitle="CyberChat"
                hideHeader
                handleEnd={this.handleEnd}
                botDelay={2000}
                userDelay={500}
                botAvatar={botAvatar}
                hideUserAvatar={true}
                steps={mySteps}
              />
            )}
          </Fade>
        </div>

        <div className="box-layout__box-center">
          <div style={{ marginBottom: '5px' }}>
            <h1 className="glow cyberFont hidden-onMobile">
              CyberPunk Project
            </h1>
          </div>
          <div className="cyber--mobileHide">
            <div className="ui fade reveal" onClick={this.changeBackground}>
              <div className="visible content">
                <Image
                  size="big"
                  src={cyberpunk}
                  alt="cyber"
                  className="phoenix"
                />
              </div>
              <div className="hidden content">
                <Image
                  size="big"
                  className="ui small image phoenix"
                  src={street}
                  alt="cyber"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="box-layout__box">
          <h4 className="box-layout__title glow hidden-greater-600">
            CyberPunk
          </h4>
          <div className="button-bar">
            <Button
              className="ui fluid google plus button"
              onClick={this.loginGoogle}
            >
              <i className="google plus icon" />
              Login with Google
            </Button>
            <Button
              style={{ marginTop: '5px' }}
              className="ui fluid twitter button"
              onClick={this.loginTwitter}
            >
              <i className="twitter icon" />
              Login with Twitter
            </Button>
            <Button
              style={{ marginTop: '5px' }}
              className="ui fluid inverted violet basic animated button"
              onClick={this.helpBot}
            >
              <div className="visible content">
                <i className="help icon" />
                Help
              </div>
              <div className="hidden content">
                <i className="skype icon" />
                CyberBot Chat
              </div>
            </Button>
            <div className="phoenixGit">
              <i className="github icon"></i>
              <div>inPhoenix</div>
            </div>
            {this.state.enableOffline && this.disconnected()}
          </div>

          <div>
            {/*<div className="ui vertical" tabIndex="0" style={{ marginTop: '10px' }}>
            <div className="visible content">
              <i className="github icon"></i>
            </div>
          </div>*/}
          </div>

          {/*<Button
            className="ui react button"
            onClick={() => this.props.history.push('/')}
          >Direct</Button>*/}
        </div>
      </div>
    )
  }
}

function mapState(state, ownProps) {
  return {
    user: state.user
  }
}

export default withRouter(
  connect(mapState, { googleLogin, twitterLogin })(Login)
)



// WEBPACK FOOTER //
// ./src/components/Login.js